var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';
import Title from '../../atoms/Title';
import Desc from '../../atoms/Desc';
import { VerticalGap } from '../../atoms/Gap/Gap';
import CtaBtn from '../../atoms/CtaBtn';
import { neutralDay, scc, wBody1, wBody4 } from '@teamsparta/design-system';
import { useAtom } from 'jotai/index';
import { readWriteModalHistoryAtom } from '../../../stores';
import { BottomContents, MainContents } from '../../../styles/_common.style';
import styled from '@emotion/styled';
import { useIsMobile, useQueryStringParams } from '../../../businessLogics/hooks';
import { validateBirth, validateEmail, validateName } from '../../../businessLogics';
import { useSignupEmail } from '../../../businessLogics/apis';
import LoadingSpinner from '../../atoms/Spinner';
var SignupKakao = function (_a) {
    var setIsShow = _a.setIsShow, CPLogger = _a.CPLogger;
    var _b = useState('/'), nextPage = _b[0], setNextPage = _b[1];
    var _c = useAtom(readWriteModalHistoryAtom), _ = _c[0], updateHistory = _c[1];
    var isMobile = useIsMobile();
    var _d = useState(false), isButtonDisabled = _d[0], setIsButtonDisabled = _d[1];
    var query = useQueryStringParams();
    var _e = useState(0), kkoId = _e[0], setKkoId = _e[1];
    var _f = useState(''), name = _f[0], setName = _f[1];
    var _g = useState(''), email = _g[0], setEmail = _g[1];
    var _h = useState(''), phoneNumber = _h[0], setPhoneNumber = _h[1];
    var _j = useState(null), marketing = _j[0], setMarketing = _j[1];
    var _k = useState(''), birthday = _k[0], setBirthday = _k[1];
    var _l = useState('undefined'), gender = _l[0], setGender = _l[1];
    var _m = useState('82'), countryCode = _m[0], setCountryCode = _m[1];
    var _o = useState(''), current = _o[0], setCurrent = _o[1];
    var signUpRequest = useSignupEmail(setIsShow, setIsButtonDisabled, CPLogger, nextPage);
    useEffect(function () {
        var _a;
        setNextPage(query.get('next') || '/');
        setKkoId(Number(query.get('kko_id')));
        setName(query.get('name') || '');
        setEmail(query.get('email') || '');
        setPhoneNumber(query.get('phone') || '');
        setMarketing(query.get('marketing') === 'true');
        var _birthyear = query.get('birthyear') || '1997';
        var _birthday = query.get('birthday') || '0101';
        setBirthday(_birthyear + _birthday);
        setGender(query.get('gender') || '');
        setCountryCode(((_a = query.get('country_code')) === null || _a === void 0 ? void 0 : _a.replace('+', '')) || '82');
        setCurrent(query.get('current') || '');
    }, [query]);
    var generalCheck = function () {
        return (kkoId !== 0 &&
            name !== '' &&
            email !== '' &&
            phoneNumber !== '' &&
            marketing !== null &&
            birthday !== '' &&
            countryCode !== '' &&
            validateEmail(email) &&
            validateName(name) &&
            validateBirth(birthday));
    };
    var signUp = function () {
        if (generalCheck()) {
            signUpRequest.mutate({
                name: name,
                email: email,
                password: 'welcomeSparta',
                phone: phoneNumber,
                countryCode: countryCode,
                gender: gender,
                birthday: birthday,
                marketingAgreement: marketing,
                kkoId: kkoId,
                current: current,
            });
        }
        else {
            alert('잠시 후에 다시 눌러주세요!\n이 현상이 지속되면 이메일로 회원가입을 시도해주세요.');
        }
    };
    var throttledSignUp = throttle(signUp, 1000, { trailing: false }, [name, email, phoneNumber, marketing, kkoId]);
    var ctaButton = function (isButtonDisabled) {
        return (_jsx(_Fragment, { children: _jsx(CtaBtn, __assign({ bgColor: isButtonDisabled ? scc.red50 : scc.red100, color: neutralDay.white, isInactive: isButtonDisabled, onClickAction: isButtonDisabled
                    ? function (e) {
                        e.stopPropagation();
                    }
                    : throttledSignUp }, { children: isButtonDisabled ? (_jsx(LoadingSpinner, { src: "".concat(process.env.REACT_APP_CDN_LOGIN_URL, "/loading.png") })) : ('가입하기') })) }));
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 80, isCenterInMobile: true }, { children: [_jsx(Title, { children: "\uC778\uC99D \uC131\uACF5!" }), _jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsx(Desc, { children: "\uC544\uB798\uC758 \uC774\uBA54\uC77C\uB85C \uD68C\uC6D0\uAC00\uC785\uC774 \uC644\uB8CC\uB429\uB2C8\uB2E4." })] }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsxs(Display, { children: [email, _jsx("br", {})] }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), ctaButton(isButtonDisabled)] }))] })), isMobile && _jsx(BottomContents, { children: ctaButton(isButtonDisabled) })] }));
};
export default SignupKakao;
var Display = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 59px 69px;\n  box-sizing: border-box;\n  gap: 8px;\n  width: 100%;\n  height: 102px;\n  background: ", ";\n  border-radius: 12px;\n  ", ";\n  color: ", ";\n  line-height: 1;\n\n  span {\n    ", ";\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 59px 69px;\n  box-sizing: border-box;\n  gap: 8px;\n  width: 100%;\n  height: 102px;\n  background: ", ";\n  border-radius: 12px;\n  ", ";\n  color: ", ";\n  line-height: 1;\n\n  span {\n    ", ";\n    color: ", ";\n  }\n"])), neutralDay.gray0, wBody1, neutralDay.gray100, wBody4, neutralDay.gray60);
var templateObject_1;
//# sourceMappingURL=SignupKakao.js.map